import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  item: {
    position: 'relative',
    marginBottom: theme.spacing(4)
  },
  remove: {
    position: 'absolute',
    minWidth: 'inherit',
    borderRadius: '16px !important',
    padding: 8,
    height: 32,
    top: -8,
    right: -8
  }
}))

export {
  useStyles
}
